import { GetOrdersInTransportInput } from '../../Orders/GetOrdersInTransport/GetOrdersInTransportInput';

export class GenerateTransportOrderBaseReportInput {
  includeHeaders: boolean = true;
  returnStringData: boolean = false;
  filter: GetOrdersInTransportInput;
}